module.exports = __webpack_public_path__ + "static/media/azure-active-directory.51b3a4b6.svg";